module.exports = __webpack_public_path__ + "img/20220411_130412.a1e7ac00.jpg";